import { render, staticRenderFns } from "./score-card-list-table.vue?vue&type=template&id=4ba483f0&scoped=true"
import script from "./score-card-list-table.vue?vue&type=script&lang=js"
export * from "./score-card-list-table.vue?vue&type=script&lang=js"
import style0 from "./score-card-list-table.vue?vue&type=style&index=0&id=4ba483f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba483f0",
  null
  
)

export default component.exports